const AGENT_ONLY_PRODUCT_IDS = new Set([1, 2, 3, 4, 5, 6, 7, 8])

export const getOrderUser = (order: any): any => order?.User?.data?.attributes ?? order?.User?.attributes ?? order?.User ?? {}

const getProductId = (order: any): number | undefined => {
    const value = order?.ProductID ?? order?.ProductId ?? order?.productID ?? order?.orderID ?? order?.OrderID
    const parsed = Number(value)
    return Number.isFinite(parsed) ? parsed : undefined
}

/** Category is the existing user capability field. It may contain more than one capability during account switching. */
export const hasLandlordCapability = (user: any): boolean => {
    const category = user?.Category
    const values = Array.isArray(category) ? category : [category]
    return values.some((value) => String(value ?? '').toLowerCase().split(/[^a-z]+/).includes('landlord'))
}

/** Counts canonical user records by id so duplicate pagination rows cannot inflate the landlord total. */
export const countLandlordCapableUsers = (users: any[]): number => {
    const userIds = new Set<string>()
    users.forEach((record) => {
        const user = record?.attributes ?? record
        const id = user?.id ?? record?.id
        if (id != null && hasLandlordCapability(user)) userIds.add(String(id))
    })
    return userIds.size
}

export const isConfirmedLegacyFreeBrokerOrder = (order: any): boolean => {
    if (order?.ServiceRef != null || getProductId(order) != null) return false
    return Array.isArray(order?.Service) && order.Service.some((service: any) => service?.__component === 'services.broker-subscription')
}

export const isConfirmedAgentOnlyOrder = (order: any): boolean => {
    const productId = getProductId(order)
    return (productId != null && AGENT_ONLY_PRODUCT_IDS.has(productId)) || isConfirmedLegacyFreeBrokerOrder(order)
}

/** Unknown orders remain visible for landlord-capable users so operational landlord orders are never silently lost. */
export const shouldIncludeLandlordServiceOrder = (order: any): boolean => {
    return hasLandlordCapability(getOrderUser(order)) && !isConfirmedAgentOnlyOrder(order)
}

export { AGENT_ONLY_PRODUCT_IDS, getProductId }
